// src/features/engine/flowComponentRegistry.js

import ProgramIntro from "../projects/components/ProjectIntro";
import ProgramCompletion from "../projects/components/ProjectCompletion";
import ProgramResults from "../projects/components/ProjectResults";

import TaskExecutor from "./runners/TaskExecutor";

const flowComponentRegistry = {

  ProgramIntro,
  ProgramCompletion,
  ProgramResults,

  TaskExecutor

};

export default flowComponentRegistry;